import {daysBetweenDates} from "utils/utils"
import { defaultLang } from "locales/config";

function getLocale(item, field, currentLang){
    const localizations = item?.localizations;
    if (localizations) {
      let locale = localizations.find((l) => l.locale == currentLang.value);
      if (locale) {
        return locale[field]
      }
    }
}

export function ExtractData(data) {
  const current = localStorage.getItem("i18nextLng")
  const currentLang = {value: current ? current : defaultLang.value};
  
  var rows = [];
  data[0].accommodations.forEach((item, index) => {
    let name = (current != defaultLang.value) ? getLocale(item, 'name', currentLang) : item.name;
    rows.push({
      accommodationName: name,
      accommodationID: item.id,
      remainingQuantity: [],
      rateplans: [],
    });
    item.rate_plans.forEach((rate, idx) => {
      let ratePlanName = (current != defaultLang.value) ? getLocale(rate, 'name', currentLang) : rate.name;
      rows[index].rateplans.push({
        name: ratePlanName,
        ratePlanID: rate.id,
        availability: [],
        still_available_in_that_date: [],
        minStay: [],
        minAdvance: [],
        prezziari: [],
      });
      rate.prezziari.forEach((prezziario) => {
        rows[index].rateplans[idx].prezziari.push({
          prezziarioID: prezziario.id,
          guests: prezziario.tot_guests,
          base_price: [],
          BB: [],
          HB: [],
          FB: [],
        });
      });
    });
  });

  //riempire remainingQuantity
  data.forEach((item) => {
    let nAcc = item.accommodations.length;
    for (let i = 0; i < nAcc; i++) {
      //riempire accommodations[i.remainingQuantity
      rows[i].remainingQuantity.push(item.accommodations[i].quantity);

      //riempire i rateplans[j].minStay .availability
      let nRatePlans = item.accommodations[i].rate_plans.length;
      for (let j = 0; j < nRatePlans; j++) {
        rows[i].rateplans[j].minStay.push(
          item.accommodations[i].rate_plans[j]?.minStay
        );
        rows[i].rateplans[j].minAdvance.push(
          item.accommodations[i].rate_plans[j]?.minAdvance
        );
        rows[i].rateplans[j].availability.push(
          item.accommodations[i].rate_plans[j].availability
        );
        rows[i].rateplans[j].still_available_in_that_date.push(
          item.accommodations[i].rate_plans[j].still_available_in_that_date
        );

        //riempire prezziari[k].BB .HB .FB .base_price
        let nPrezziari = item.accommodations[i].rate_plans[j].prezziari.length;
        for (let k = 0; k < nPrezziari; k++) {
          rows[i].rateplans[j].prezziari[k].base_price.push(
            item.accommodations[i].rate_plans[j].prezziari[k].base_price
          );

          let treatments = item.accommodations[i].rate_plans[j].prezziari[
            k
          ].treatments.map((treatment) => treatment.name);
          //if breakfast included
          if (
            item.accommodations[i].rate_plans[j].prezziari[k].breakfast_included
          )
            rows[i].rateplans[j].prezziari[k].BB.push({
              value: 0,
              disabled: true,
            });
          else {
            //find indexOf treatment BB
            let BBindex = treatments.indexOf("BB");
            if (BBindex >= 0) {
              rows[i].rateplans[j].prezziari[k].BB.push({
                value:
                  item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                    BBindex
                  ].pricePerPerson,
                treatmentID:
                  item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                    BBindex
                  ].id,
              });
            }
          }

          //HB
          let HBindex = treatments.indexOf("HB");
          if (HBindex >= 0) {
            rows[i].rateplans[j].prezziari[k].HB.push({
              value:
                item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                  HBindex
                ].pricePerPerson,
              treatmentID:
                item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                  HBindex
                ].id,
            });
          }

          //FB
          let FBindex = treatments.indexOf("FB");
          if (FBindex >= 0) {
            rows[i].rateplans[j].prezziari[k].FB.push({
              value:
                item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                  FBindex
                ].pricePerPerson,
              treatmentID:
                item.accommodations[i].rate_plans[j].prezziari[k].treatments[
                  FBindex
                ].id,
            });
          }
        }
      }
    }
  });

  //console.log(rows)
  return rows;
}

export function ExtractCouponData(data, coupon, firstDay){
  const current = localStorage.getItem("i18nextLng")
  const currentLang = {value: current ? current : defaultLang.value};

  let startingIndex = daysBetweenDates(new Date(firstDay.toISOString().split("T")[0]), new Date(coupon.start));
  startingIndex = Math.max(0, startingIndex);
  let endingIndex = daysBetweenDates(new Date(firstDay.toISOString().split("T")[0]), new Date(coupon.end)) -1;
  endingIndex = Math.min(13, endingIndex);
  let len = endingIndex-startingIndex+1

  var rows = [];
  data[0].accommodations.forEach((item) => {
    let name = (current != defaultLang.value) ? getLocale(item, 'name', currentLang) : item.name;
    rows.push({
      accommodationName: name,
      accommodationID: item.id,
      quantity: new Array(14).fill(0),
      remaining: new Array(14).fill(0),
      BB: new Array(14).fill(true),
      HB: new Array(14).fill(false),
      FB: new Array(14).fill(false),
      start: new Date(coupon.start),
      end: new Date(coupon.end),
    })
  });

  for(let i=startingIndex; i<=endingIndex; i++){
    for(let j=0; j<rows.length; j++){
      let couponInfo = data[i].accommodations[j].coupons.find((item)=>item.id == coupon.id)
      //console.log(couponInfo)
      rows[j].quantity[i] = couponInfo?.quantity
      rows[j].remaining[i] = couponInfo?.remaining
      rows[j].HB[i] = couponInfo?.HB
      rows[j].FB[i] = couponInfo?.FB
    }
  }

  return rows;
}